import React from "react";
import "./AboutCostaBlanca.css";
import thing1 from "../../img/3things/thing1.png";
import thing2 from "../../img/3things/thing2.png";
import thing3 from "../../img/3things/thing3.png";
import { motion } from "framer-motion";

function AboutCostaBlanca() {
  const fadeInUp = {
    hidden: { opacity: 1, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };
  return (
    <div className="AboutCostaBlanca">
      <h1>A unique experience</h1>
      <div className="AboutCostaBlanca__things__width">
        <div className="AboutCostaBlanca__things">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.01 }}
            variants={fadeInUp}
          >
            <div className="AboutCostaBlanca__thing__section">
              <img src={thing1} alt="Luxury villa with sea view in Costa Blanca, Spain" />
              <h3>A Blend of History</h3>
              <p>
                Costa Blanca is a treasure trove of history, where ancient Roman
                ruins meet stunning Moorish castles. Stroll through charming old
                towns filled with whitewashed homes and timeless Mediterranean
                architecture.
              </p>
            </div>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.01 }}
            variants={fadeInUp}
          >
          <div className="AboutCostaBlanca__thing__section">
            <img src={thing2} alt="Luxury villa with sea view in Costa Blanca, Spain" />
            <h3>Coastal Beauty</h3>
            <p>
              With golden beaches, hidden coves, and crystal-clear waters, Costa
              Blanca’s coastline is pure luxury. From private yachts to
              exclusive seaside escapes, it offers the ultimate in relaxation
              and sophistication.
            </p>
          </div>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.01 }}
            variants={fadeInUp}
          >
          <div className="AboutCostaBlanca__thing__section">
            <img src={thing3} alt="Luxury villa with sea view in Costa Blanca, Spain" />
            <h3>Year-Round Sun</h3>
            <p>
              Enjoy over 300 days of sunshine annually. Costa Blanca’s perfect
              weather invites you to bask in warmth, whether on a golf course,
              by the beach, or dining under the stars.
            </p>
          </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default AboutCostaBlanca;
